import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "@mhome/ui/dist/index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { RecoilRoot } from "recoil";
import { Helmet, HelmetProvider } from "react-helmet-async";

// Create a wrapper component
const CacheControlWrapper = ({ children }) => (
  <>
    <Helmet>
      <meta
        httpEquiv="Cache-Control"
        content="no-cache, no-store, must-revalidate"
      />
      <meta httpEquiv="Pragma" content="no-cache" />
      <meta httpEquiv="Expires" content="0" />
    </Helmet>
    {children}
  </>
);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <CacheControlWrapper>
        <RecoilRoot>
          <App />
        </RecoilRoot>
      </CacheControlWrapper>
    </HelmetProvider>
  </React.StrictMode>
);

reportWebVitals();
